//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Api from '~/services/api';
import TaskChat from '~/components/chat/TaskChat.vue';

export default {
  components: { TaskChat },
  props: {
    params: {
      type: Object,
      default: null,
    },
  },
  data() {
    return { order: null, messages: [], profiles: {}, status: '' };
  },
  async mounted() {
    const chatroomId = this.params.chatId;
    await Api.openChatroom(this, chatroomId);
    const response = await Api.getChatroomMessages(this, chatroomId);
    const messages = response.messages;
    this.messages = messages;
    this.profiles = response.profiles;
    this.status = response.chatroom.status;
    this.socket = this.$socketio().onMessage(async (message) => {
      if (
        message.entityType === 'chatrooms' &&
        message.entityId === chatroomId
      ) {
        const response = await Api.getChatroomMessages(this, chatroomId);
        const messages = response.messages;
        this.messages = messages;
      }
    });
  },
  beforeDestroy() {
    this.socket?.removeListeners();
  },
  methods: {
    onMessage(message) {
      this.messages.push(message);
    },
  },
};
